import { Component, OnInit } from '@angular/core';
import { Merchant } from 'src/app/common/models/merchant';
import { Operator } from 'src/app/common/models/operator';
import { Plan } from 'src/app/common/models/plan';
import { OperatorDetails } from 'src/app/models/operator-details';
import { AuthService } from 'src/app/services/auth-service';
import { ProviderService } from 'src/app/services/provider.service';

@Component({
  selector: 'app-operators',
  templateUrl: './operators.component.html',
  styleUrls: ['./operators.component.css'],
})
export class OperatorsComponent implements OnInit {
  merchants: Merchant[] = [];
  operator: string = '';
  merchant: string = '';
  operatorDetails: OperatorDetails[] = [];
  operatorDetailsArchive: OperatorDetails[] = [];
  date = null;
  selectedPlans: string[] = [];
  dateRange: Date[] = [];
  subscription: any = null;
  constructor(private providerService: ProviderService
    , private authService : AuthService
  ) {}

  ngOnInit() {
    
    this.subscription  = this.providerService.onChangeOperator$.subscribe(res => {
      this.operatorDetails = [];
      this.operatorDetailsArchive = [];
    });
  }
  loading = false;
  archiveLoading = false;


  operatorEvent(operator: Operator) {
    // this.loadMerchants(operator.id);
    this.operator = operator.id;
    this.merchant = '';
  }

  getTotalRevenue(){
    const totalRevenue = this.operatorDetails.reduce((sum, details) => sum + details.revenue, 0);
    return totalRevenue;
  }
  getTotalBase(){
    const totalRevenue = this.operatorDetails.reduce((sum, details) => sum + details.totalBase, 0);
    return totalRevenue;
  }
  getTotalActivation(){
    const totalRevenue = this.operatorDetails.reduce((sum, details) => sum + details.newActive, 0);
    return totalRevenue;
  }
  getTotalChurn(){
    const totalRevenue = this.operatorDetails.reduce((sum, details) => sum + details.churn, 0);
    return totalRevenue;
  }
  getTotalRenewal(){
    const totalRevenue = this.operatorDetails.reduce((sum, details) => sum + details.renewalTotalSuccess, 0);
    return totalRevenue;
  }

  getArchiveTotalRevenue(){
    const totalRevenue = this.operatorDetailsArchive.reduce((sum, details) => sum + details.revenue, 0);
    return totalRevenue;
  }
  getArchiveTotalBase(){
    const totalRevenue = this.operatorDetailsArchive.reduce((sum, details) => sum + details.totalBase, 0);
    return totalRevenue;
  }

  getArchiveTotalActivation(){
    return this.operatorDetailsArchive.reduce((sum, details) => sum + details.newActive, 0);
    
  }
  getArchiveTotalChurn(){
    return this.operatorDetailsArchive.reduce((sum, details) => sum + details.churn, 0);
     
  }
  getArchiveTotalRenewal(){
    return this.operatorDetailsArchive.reduce((sum, details) => sum + details.renewalTotalSuccess, 0);
     
  }
  
  onSelectMerchant(merchant: Merchant | null) {
    this.merchant = merchant?.id ?? ''; 
  }
  loadMerchants(operator: string) {
    this.providerService.loadMerchants(operator).subscribe((merchants) => {
      this.merchants = merchants;
    });
  }
  getSelectedPlans(plans: Plan[]) {
    const planIds: string[] = [];

    plans.forEach((item) => planIds.push(item.planId));
    this.selectedPlans = planIds;


    if (this.authService.getMerchantNameFromLocalStorage()) {
      this.loadOperatorDetails();
    }
  }

  loadOperatorDetails() {
    if (
      !this.selectedPlans ||
      !this.operator ||
      this.selectedPlans.length == 0
    ) {
      return;
    }

    this.loading = true;

    this.providerService
      .getOperatorDetails(this.operator, this.selectedPlans)
      .subscribe({
        next: (details) => {
          this.loading = false;
          this.operatorDetails = details;
        },
        error: (error) => {
          this.loading = false;
          this.operatorDetails = [];
        },
      });
  }

  loadOperatorDetailsArchive(
    operator: string,
    planIds: string[],
    fromDate: Date,
    toDate: Date
  ) {
    if (!planIds || !operator || planIds.length == 0) {
      return;
    }
    this.archiveLoading = true;

    this.providerService
      .getOperatorDetails(operator, planIds, 'archive', fromDate, toDate)
      .subscribe({
        next: (details) => {
          this.operatorDetailsArchive = details;
          this.archiveLoading = false;
        },
        error: (error) => {
          this.operatorDetailsArchive = [];
          this.archiveLoading = false;
        },
      });
  }

  onDateRangeChange(result: Date[]): void {
    this.dateRange = result;
  }

  onArchiveSearch() {
    if (!this.operator || this.dateRange.length <= 0) {
      return;
    }

    this.loadOperatorDetailsArchive(
      this.operator,
      this.selectedPlans,
      this.dateRange[0],
      this.dateRange[1]
    );
  }



  ngOnDestroy(): void {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
